/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { useStaticQuery, graphql } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n";
import SectionHeadline from '../../../components/SectionHeadline'
import CommonSection from "../../../components/CommonSection";
import LinkItem from "../../../components/LinkItem"
import styled from '@emotion/styled';
import IconPackage from 'xiv-fanfes-2021'
import * as breakpoint from '../../../styles/breakpoints.module.scss';

import AnimatedSection from '../../../components/AnimatedSection';

const CategorySection = ({ currentSection, type, currentTag }) => {

  const { t, localeKey, currentLocaleObj } = useLocalization();
  const { categories } = useStaticQuery(graphql`
    query CategorySection {
      categories : allFanArtContestCategory(sort: {order: ASC, fields: order}) {
        edges {
          node {
            key
            total
            title {
              ...localizedContent
            }
            url {
              ...localizedContent
            }
          }
        }
      }
    }
  `);


  return (
    <AnimatedSection>
      <CategoryWrapper className={currentSection === "" ? "landing" : "inner"}>
        {(currentSection === "" && type !== "winners") &&
          <SectionHeadline 
            title={t(`fan_art_contest.contest.${type ? type : 'categories'}.title`)} 
            subtitle={t(`fan_art_contest.contest.${type ? type : 'categories'}.subtitle`)}
          />
        }
        {(currentSection === "" && type === "winners")  &&
          <SectionHeadline 
            icon={'Meteor'}
            color={'#D00F31'}
            title={t('fan_art_contest.contest.awards.title')} 
            subtitle={t('fan_art_contest.contest.awards.subtitle')}
            css={css`
              .subtitle{
                color:#D00F31;
              }
            `}
          />
        }
        <CategoryList>
        {categories.edges.map(({node}) => {
          let path = type === "winners" ? `/${currentLocaleObj.prefix}/activity/fan-art-contest/winners/${node.key}/${currentTag ? currentTag : 'amazing'}` : type === "entry" ? `/${currentLocaleObj.prefix}/activity/fan-art-contest/entry/${node.key}/1` : `/${currentLocaleObj.prefix}/activity/fan-art-contest/${node.key}/1`;
          return(<Category 
            fade
            to={path} 
            category={node.key}
            key={`category_${node.key}`} 
            className={`category ${node.key} ${currentSection === node.key ? 'current' : ''}`}>
            <IconPackage.Icon type={node.key} className={'icon'}/>
            <span className="title">{node.title[localeKey]}</span>
            <IconPackage.Icon type={'Arrow'} className={'arrow'} />
          </Category>)
        })}
        </CategoryList>
      </CategoryWrapper>
      
    </AnimatedSection>
  );
}
 
export default CategorySection;


const CategoryWrapper = styled(CommonSection)`
  background:none;
  > div{
    max-width:calc(928px + 96px);
    display:block;
  }
  &.landing{
    > div{
      padding-top:48px;
      padding-bottom:0px;
    }
  }
  &.inner{
    >div{
      padding-top:0; margin-top:-48px;
    }
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
   >div{
     max-width:none;
   } 
   &.landing{
    > div{
      padding-top:32px;
      padding-bottom:0px;
    }
  }
   &.inner{
      >div{
        margin-top:-32px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
  &.landing{
    > div{
      padding-top:16px;
      padding-bottom:0px;
    }
  }
   &.inner{
      >div{
        margin-top:-16px;
      }
    }
  }
`

const CategoryList = styled.div`
  display:flex;
  padding:0px 16px 0;
  margin:0 -32px;

  .landing &{
    padding-top:48px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    .landing &{
      padding-top:32px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    flex-wrap:wrap;
    padding:0;
    margin:0 -8px;
    .landing &{
      padding-top:16px;
    }
  }

  
`

const catColor = {
  "ilw" : {
    "default" : "#D32F2F",
    "hover" : "#F44336"
  },
  "phw" : {
    "default" : "#F57C00",
    "hover" : "#FF9800"
  },
  "ssu" : {
    "default" : "#388E3C",
    "hover" : "#4CAF50"
  },
  "ssa" : {
    "default" : "#0288D1",
    "hover" : "#03A9F4"
  }
}

const Category = styled(LinkItem)`
  display:block;
  background: #F7F7FA;
  border: 4px solid ${props => catColor[props.category].default};
  box-sizing: border-box;
  border-radius: 6px;
  margin:0 16px;
  width:calc(100% - 32px);
  padding:24px 16px 48px;
  text-decoration:none;
  text-align:center;
  position:relative;

  svg.icon{
    color: ${props => catColor[props.category].default};
    width:80px;
    height:80px;
    display:block;
    margin:0 auto;
  }

  .title{
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.03em;
    color: #4E4E50;
    font-weight: 900;
    display:flex;
    height:48px;
    flex-direction:column;
    justify-content:center;
  }

  svg.arrow{
    width:32px;
    height:32px;
    transform: translateX(-50%) rotate(90deg);
    color:#4E4E50;
    position:absolute;
    bottom:8px;
    left:50%;
  }

  &:hover{
    background:#FFFFFF;
    border-color: ${props => catColor[props.category].hover};
    box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
    svg.icon{
      color: ${props => catColor[props.category].hover};
    }
  }

  &:active{
    background: ${props => catColor[props.category].hover};
    box-shadow: none;
    svg.icon, .title, svg.arrow{
      color:#FCFCFF;
    }
  }

  &.current{
    background: ${props => catColor[props.category].default};
    border-color: ${props => catColor[props.category].default};
    box-shadow: none;
    svg.icon, .title, svg.arrow{
      color:#FCFCFF;
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:24px 8px 28px;
    svg.icon{
      width:40px;
      height:40px;
    }

    .title{
      font-size: 11px;
      line-height: 16px;
      height:32px;
    }
    svg.arrow{
      width:16px;
      height:16px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:calc(50% - 16px);
    margin:0 8px 16px;
  }


`
